import { IStore } from '../index'

export const getOverviewSelectedDates = (state: IStore) => ({
  dateFrom: state.overview.dateFrom,
  dateTo: state.overview.dateTo,
})

export const getOverviewSelectedIndex = (state: IStore) =>
  state.overview.selectedIndex

export const getOverviewError = (state: IStore) => state.overview.error

export const getOverviewDifferencePeriod = (state: IStore) =>
  state.overview.differencePeriod

export const getOverviewSelectedRooms = (state: IStore) =>
  state.overview.selectedRooms

export const getOverviewStatsOcupancy = (state: IStore) =>
  state.overview.stats.ocupancy

export const getOverviewStatsIncome = (state: IStore) =>
  state.overview.stats.income

export const getOverviewStatsEvents = (state: IStore) =>
  state.overview.stats.events

export const getOverviewStatsEventsCanceled = (state: IStore) =>
  state.overview.stats.eventsCancelled

export const getOverviewStatsAvgDays = (state: IStore) =>
  state.overview.stats.avgDays

export const getOverviewStatsAvgDaysAb = (state: IStore) =>
  state.overview.stats.avgDaysAb

export const getOverviewStatsBookingWindow = (state: IStore) =>
  state.overview.stats.bookingWindow

export const getOverviewStatsADR = (state: IStore) => state.overview.stats.ADR

export const getOverviewStatsRevPAR = (state: IStore) =>
  state.overview.stats.RevPAR

export const getOverviewStatsOcupancyDiff = (state: IStore) =>
  state.overview.stats.diffStats && state.overview.stats.diffStats.ocupancy

export const getOverviewStatsIncomeDiff = (state: IStore) =>
  state.overview.stats.diffStats && state.overview.stats.diffStats.income

export const getOverviewStatsEventsDiff = (state: IStore) =>
  state.overview.stats.diffStats && state.overview.stats.diffStats.events

export const getOverviewStatsEventsCanceledDiff = (state: IStore) =>
  state.overview.stats.diffStats &&
  state.overview.stats.diffStats.eventsCancelled

export const getOverviewStatsAvgDaysDiff = (state: IStore) =>
  state.overview.stats.diffStats && state.overview.stats.diffStats.avgDays

export const getOverviewStatsAvgDaysAbDiff = (state: IStore) =>
  state.overview.stats.diffStats && state.overview.stats.diffStats.avgDaysAb

export const getOverviewStatsBookingWindowDiff = (state: IStore) =>
  state.overview.stats.diffStats && state.overview.stats.diffStats.bookingWindow

export const getOverviewStatsADRDiff = (state: IStore) =>
  state.overview.stats.diffStats && state.overview.stats.diffStats.ADR

export const getOverviewStatsRevPARDiff = (state: IStore) =>
  state.overview.stats.diffStats && state.overview.stats.diffStats.RevPAR
